import React from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './TrialWarningBanner.css';

const TrialWarningBanner: React.FC = () => {
  const { trialStatus, userProfile } = useAuth();
  const navigate = useNavigate();

  // Don't show if not on trial, trial is expired, or not within warning threshold
  if (!trialStatus?.showWarning || trialStatus.isTrialExpired) {
    return null;
  }

  // Don't show if user is in grace period (GracePeriodBanner handles that)
  if (userProfile?.accountStatus === 'grace_period') {
    return null;
  }

  const { daysRemaining } = trialStatus;
  const dayText = daysRemaining === 1 ? 'day' : 'days';

  return (
    <Alert variant="info" className="trial-warning-banner mb-0">
      <div className="trial-warning-content">
        <div className="trial-warning-text">
          <strong>Free Trial Ending Soon</strong>
          <span className="trial-warning-message">
            Your free trial expires in {daysRemaining} {dayText}. Subscribe now to keep using Revealer.
          </span>
        </div>
        <div className="trial-warning-actions">
          <Button
            variant="primary"
            size="sm"
            onClick={() => navigate('/select-plan')}
            className="subscribe-btn"
          >
            Subscribe Now
          </Button>
        </div>
      </div>
    </Alert>
  );
};

export default TrialWarningBanner;
